module.exports = __webpack_public_path__ + "static/media/icon_code_finish.248c11fe.svg";